// LoaderProvider.js
import React, { Component } from 'react';
import LoaderContext from './LoaderContext';

class LoaderProvider extends Component {
    state = {
        loading: false,
    };

    setLoading = (loading) => {
        this.setState({ loading });
    };

    render() {
        return (
            <LoaderContext.Provider
                value={{
                    loading: this.state.loading,
                    setLoading: this.setLoading,
                }}
            >
                {this.props.children}
            </LoaderContext.Provider>
        );
    }
}

export default LoaderProvider;
